module.exports = __webpack_public_path__ + "static/media/SRPB77.2cd4d682.png";